import React from "react";
import { RESTAURANT } from "@/lib/content";
import { useSiteContent } from "@/lib/site-content";

export default function Footer() {
  const { content } = useSiteContent();
  const c = content.contact;
  const phone = c.phone || RESTAURANT.phone;
  const email = c.email || RESTAURANT.email;

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1A1A1A] text-white py-14"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16">
        <div className="flex flex-col md:flex-row gap-10 md:gap-6 md:items-end md:justify-between">
          <div>
            <div className="flex items-center gap-3">
              <div className="h-11 w-11 rounded-xl overflow-hidden bg-[#F5ECE1]">
                <img
                  src={RESTAURANT.logo}
                  alt="Thai Noodle & Rice logo"
                  className="h-full w-full object-cover"
                />
              </div>
              <div className="font-display font-black text-xl">
                Thai Noodle & Rice
              </div>
            </div>
            <p className="mt-4 text-sm text-white/65 max-w-md leading-relaxed">
              A tiny Thai kitchen tucked above George Street. Real Bangkok
              flavours, wok-fired daily in the heart of Manchester Chinatown.
            </p>
          </div>
          <div className="flex flex-col gap-2 text-sm text-white/70">
            <a
              href={`tel:${phone.replace(/\s/g, "")}`}
              className="hover:text-[#F5A623] transition-colors"
            >
              {phone}
            </a>
            <a
              href={`mailto:${email}`}
              className="hover:text-[#F5A623] transition-colors"
            >
              {email}
            </a>
            <div>
              {c.address_line1}, {c.postcode}
            </div>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-white/50">
          <div>
            © {new Date().getFullYear()} Thai Noodle & Rice Chinatown MCR. All
            rights reserved.
          </div>
          <div className="italic">รสชาติคนไทย 100% · Made with ❤ in Manchester</div>
        </div>
      </div>
    </footer>
  );
}
